
<template>
  <div>
    <div
      v-if="!showprogress"
      class="page-header"
    >
      <!--
        <video autoplay muted loop id="myVideo">
        <source src="img/TorontoTimelapse.mp4" type="video/mp4" />
        </video>      
        -->

      <div
        v-if="!showprogress"
        class="content-center"
      >
        <div class="container">
          <h2
            class="title"
            v-html="'Search by Booking or Container Number'"
          >
            Search by Booking or Container Number
          </h2>
          <input
            v-model="bookingnumber"
            class="custom_form text-center"
          >   
          <button
            type="button"
            class=" btn-lg hoverblue"
            @click="bookingStatus"
          >
            Search
          </button>        
        </div>        
      </div>        
    </div>    

    <div
      v-if="showprogress"
      style="background-color:white; margin-top: 5%; text-align: center;"
    >
      <div class="content-center">
        <div class="container">
          <form-wizard
            ref="wizard"
            :hide-buttons="true"
            title=""
            subtitle=""
            shape="square"
            color="dodgerblue"   
            style="padding-top:5%"                    
          >
            <tab-content
              ref="planned"
              :title="'Planned'"
              icon="now-ui-icons design_app"
            >
              <!--<tab-content :title="'Planned'" icon="fal fa-2x fa-calendar" ref="planned">-->
              <div class="col-md-4 ml-auto mr-auto ">                
                <h3>{{ bookingdetails.BILL_NUMBER }}</h3>                                               
                <h3>{{ bookingdetails.TRACE_NUMBER }}</h3>
                <h4>{{ bookingdetails.WEBSTATUS }}</h4>
                <h6 v-if="bookingdetails.CODE_BEHAVIOR != `X`">
                  <small>PICKUP:</small> {{ bookingdetails.ORIGCITY }} {{ bookingdetails.ORIGPROV }} ({{ bookingdetails.PICK_UP_BY.substring(0, 10) }}) <br> 
                  <small>DELIVERY:</small> {{ bookingdetails.DESTCITY }} {{ bookingdetails.DESTPROV }} ({{ bookingdetails.DELIVER_BY.substring(0, 10) }})
                </h6> 
              </div>                
            </tab-content>
                    
            <tab-content
              ref="intransit"
              :title="'In Transit'"
              icon="now-ui-icons design_app"
            >
              <div class="ml-auto mr-auto gap">      
                <h3>{{ bookingdetails.BILL_NUMBER }}</h3>
                <h3>{{ bookingdetails.TRACE_NUMBER }}</h3>  
                <h4>{{ bookingdetails.WEBSTATUS }}</h4>        
                <h6>
                  <small>PICKUP:</small> {{ bookingdetails.ORIGCITY }} {{ bookingdetails.ORIGPROV }} ({{ bookingdetails.PICK_UP_BY.substring(0, 10) }}) <br> 
                  <small>DELIVERY:</small> {{ bookingdetails.DESTCITY }} {{ bookingdetails.DESTPROV }} ({{ bookingdetails.DELIVER_BY.substring(0, 10) }})                                
                </h6>      
              </div>                
            </tab-content>
                    
            <tab-content
              ref="completed"
              :title="'Completed'"
              icon="now-ui-icons design_app"
            >
              <div class="ml-auto mr-auto gap">      
                <h3>{{ bookingdetails.BILL_NUMBER }}</h3>
                <h3>{{ bookingdetails.TRACE_NUMBER }}</h3>
                <h4>{{ bookingdetails.WEBSTATUS }}</h4>            
                <h6>
                  <small>PICKUP:</small> {{ bookingdetails.ORIGCITY }} {{ bookingdetails.ORIGPROV }} ({{ bookingdetails.PICK_UP_BY.substring(0, 10) }}) <br> 
                  <small>DELIVERY:</small> {{ bookingdetails.DESTCITY }} {{ bookingdetails.DESTPROV }} ({{ bookingdetails.DELIVER_BY.substring(0, 10) }})                                
                </h6> 
              </div>                
            </tab-content>
            <button
              type="button"
              class=" btn-lg hoverblue"
              @click="reset"
            >
              RETURN
            </button>      
          </form-wizard>                
        </div>        
      </div>  
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import {
  Button,
  Checkbox,
  Radio,
  FormGroupInput
} from '@/components';

export default {
  name: 'Bookingstatus',
  components: {    
    FormWizard,
    TabContent
  },      
  data() {
    return { 
    showprogress: false,
    bookingnumber: '',
    bookingdetails: ''
   };
  },
  watch: {      
  },
  created() {        
    
  },  
  updated(){

  },
  mounted (){
    this.bookingnumber = this.$route.query.bookingnumber
    this.bookingStatus()
  },
  methods: {
    reset (){
        this.bookingnumber = '',
        this.bookingdetails = ''
        this.showprogress = false
    },    
    bookingStatus (){        
        let vm = this
        

        axios.get('https://api.transplus.com/bookingstatus/' + this.bookingnumber.toUpperCase ())
        .then((response) => {
          console.log(response.data) // ex.: { user: 'Your User'}
          console.log(response.status) // ex.: 200
          console.log(response.data[0])
          vm.bookingdetails = response.data[0]
          
          vm.showprogress = true;        
          vm.$nextTick(()=>{
            vm.$refs.wizard.changeTab(0, vm.bookingdetails.WEBSTATUSID)
          })
            
          
        })
        .catch(e => {
          console.log(e)
        })        
        
    }    
  }
}
</script>

<style scoped>
  .custom_form {    
    border:1px solid #333;
    width: 100%;
    padding: 12px 20px;
    margin-bottom: 8px;
    font-size:2em;
    text-transform: uppercase;
  }

  .custom_form:focus {
      outline: none !important;
      border:1px solid #55B550;
      box-shadow: 0 0 4px #55B550;
  }
  .hoverblue {
  color: #999;
  background-color: rgb(245, 245, 245);
  border-width: 0;
  font-weight: bold;
  font-size: 2em;    
  margin: 20px 1px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.hoverblue:hover{
  color: white;
  background-color: dodgerblue;
}
</style>